import { slugify } from '@/lib/sanitise-strings'

import { Fragment } from 'react'

type PostTableProps = {
  items: {
    columns: string[]
    rows: React.ReactNode[][]
  }
}

export default function PostTable({ items }: PostTableProps): JSX.Element {
  const { columns, rows } = items || {}

  if (!columns || !rows) {
    return null
  }

  return (
    <div className="table-wrap custom-table">
      <div className="rounded-lg">
        <div className="table-scroll">
          <table className="reset-styles">
            <thead className="reset-styles__header">
              <tr className="reset-styles__row">
                {items.columns.map((column) => {
                  return (
                    <th
                      className={`jf-table__cell jf-table__cell--${slugify(column)}`}
                      key={`column-${column.toLowerCase()}`}
                      dangerouslySetInnerHTML={{ __html: column }}></th>
                  )
                })}
              </tr>
            </thead>

            <tbody className="reset-styles__body">
              {items.rows.map((row, rowIndex) => (
                <tr key={rowIndex} className="reset-styles__row text-17 text-grey-950">
                  {row.map((cell, cellIndex) => (
                    <Fragment key={cellIndex}>
                      {cell ? <td className="reset-styles__cell">{cell}</td> : null}
                    </Fragment>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
